var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMesseges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47618 5.0945C5.92758 5.39611 6.45829 5.55709 7.00118 5.55709C7.54407 5.55709 8.07477 5.39611 8.52618 5.0945L13.1262 2.0735C12.8263 1.45332 12.358 0.930003 11.7748 0.563343C11.1916 0.196682 10.5171 0.00146599 9.82818 0H4.17118C3.49678 0.000767031 2.83561 0.187246 2.2602 0.538984C1.68479 0.890722 1.21736 1.39413 0.90918 1.994L5.47618 5.0945Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07876 5.92652C8.46301 6.33823 7.73896 6.558 6.99826 6.558C6.25755 6.558 5.5335 6.33823 4.91776 5.92652L0.567756 2.97302C0.522871 3.20316 0.5001 3.43705 0.499756 3.67152V8.32852C0.500815 9.30194 0.887972 10.2352 1.57628 10.9235C2.26459 11.6118 3.19784 11.999 4.17126 12H9.82826C10.8017 11.999 11.7349 11.6118 12.4232 10.9235C13.1115 10.2352 13.4987 9.30194 13.4998 8.32852V3.67152C13.4985 3.46651 13.4801 3.26197 13.4448 3.06002L9.07876 5.92652Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesseges);
export default __webpack_public_path__ + "static/media/messeges.514fbe307b6be0a2eebe442d13bb3f3e.svg";
export { ForwardRef as ReactComponent };